import React from "react";

import "./OGCard.css";

/**
 * 1200×630 editorial Open Graph card. Rendered at /og only so the
 * Playwright `og` script can capture it to public/og-image.png.
 * Not linked from anywhere — search engines that hit it will just
 * see one cream-paper card.
 */
export default function OGCard() {
    return (
        <div className="og-frame">
            <div className="og-card">
                <div className="og-rule og-rule-brick" />
                <div className="og-rule og-rule-navy" />

                <header className="og-head">
                    <div className="og-brand">
                        <img
                            src="/poker-ledger-logo-half.svg"
                            alt="Poker Ledger"
                            className="og-crest"
                        />
                        <span className="og-tagline">Nothing left on the table</span>
                    </div>
                    <div className="og-eyebrow">
                        <span className="og-eyebrow-rule" />
                        The host's side of the table.
                    </div>
                </header>

                <div className="og-body">
                    <h1 className="og-headline">
                        The book that <em>balances</em> before the table breaks.
                    </h1>
                    <p className="og-lede">
                        Track Friday Night the way a good host actually thinks: who's in,
                        who's owed, who left early.
                    </p>
                </div>

                <footer className="og-foot">
                    <div className="og-tags">
                        <span>Free for 2 games a month</span>
                        <span className="og-tag-sep">·</span>
                        <span>No app store</span>
                        <span className="og-tag-sep">·</span>
                        <span>Cash-first</span>
                    </div>
                    <div className="og-url">pokerledger.club</div>
                </footer>
            </div>
        </div>
    );
}
